import { useMutation, useQueryClient } from '@tanstack/react-query'

/** A change to crash reports that refreshes every crash view when it lands. */
export function useCrashAction<A, R>(run: (args: A) => Promise<R>) {
	const client = useQueryClient()
	return useMutation({
		mutationFn: run,
		onSuccess: () => client.invalidateQueries({ predicate: (q) => String(q.queryKey[0]).startsWith('admin-crash') }),
	})
}
